import styled from 'styled-components';
import {FontSize, FontWeight, ThemesColors} from "../../../themes";
import { Button as AntButton } from 'antd';

const AccountSettingsWrapper = styled.div`
        display: none;
        position: absolute;
        top: 58px;
        width:283px;
        border-radius: 8px;
        background-color: ${ThemesColors.gray25};
        border: 1px solid #ccc;
        z-index: 999;
        padding: 10px;   
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        right: 0px;


`

const AccountInfoWrapper = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    border-bottom: ${ThemesColors.gray400} 0.5px solid;
    height: 71px;
    padding-right: 4px;
    
`

const AccountUserNameWrapper = styled.div`
    display: flex;
    flex-direction: column;
 

`

const MoodWrapper = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    margin-top: 16px;

`

const LogOutButton = styled(AntButton)`
    color: ${ThemesColors.gray700};
    text-align: center;
    font-weight: ${FontWeight.normal};
    font-size: ${FontSize.sm};
    padding: 0;
`


const PolicyMoodWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 14px;
`

const ProfilePolicyWrapper = styled.div`
display: flex;
    flex-direction: column;
    gap: 10px;
    margin-left: 3px;
`

const SwitchAccountWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left:3px;
   
`

const SwitchAccountTitle= styled.span`
 color:${ThemesColors.gray700};
  font-weight: ${FontWeight.normal};
    font-size: ${FontSize.ms};
    line-height: 0;

`

const SwitchAccountIcon = styled.img`

    width: 18px;
    height: 12.6px;
}
`

export {
    AccountSettingsWrapper,
    AccountInfoWrapper,
    AccountUserNameWrapper,
    MoodWrapper,
    LogOutButton,
    PolicyMoodWrapper,
    ProfilePolicyWrapper,
    SwitchAccountWrapper,
    SwitchAccountTitle,
    SwitchAccountIcon



}